import { render, staticRenderFns } from "./Daoshu.vue?vue&type=template&id=cbb9bd6a&"
import script from "./Daoshu.vue?vue&type=script&lang=js&"
export * from "./Daoshu.vue?vue&type=script&lang=js&"
import style0 from "./Daoshu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports